import { render, staticRenderFns } from "./EditContinuousCategoryDialog.vue?vue&type=template&id=1318062a"
import script from "./EditContinuousCategoryDialog.vue?vue&type=script&lang=js"
export * from "./EditContinuousCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports